import Vue from "vue";

export default {
  fetchCountries(_, searchQuery) {
    return new Promise((resolve, reject) => {
      const params = {
        ...(searchQuery != "" && { search_query: searchQuery }),
      };

      Vue.$http
        .get("/countries", { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },

  fetchStates(_, { searchQuery, countryId }) {
    return new Promise((resolve, reject) => {
      const params = {
        country_id: countryId,
        ...(searchQuery != "" && { search_query: searchQuery }),
      };

      Vue.$http
        .get("/states", { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchCities(_, { searchQuery, stateId }) {
    return new Promise((resolve, reject) => {
      const params = {
        state_id: stateId,
        ...(searchQuery != "" && { search_query: searchQuery }),
      };

      Vue.$http
        .get("/cities", { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  searchEmployees({ commit }, searchQuery) {
    return new Promise((resolve, reject) => {
      if (searchQuery === undefined || searchQuery === "") {
        return [];
      }

      const params = {
        ...(searchQuery != "" && { query: searchQuery }),
      };

      Vue.$http
        .get("/organization/employees/search", { params })
        .then(response => {
          commit("employees", response.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchBanks() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/banks")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
